/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Projects_Title_2Inputs */

const en_projects_title_2 = /** @type {(inputs: Projects_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`into practice.`)
};

const lv_projects_title_2 = /** @type {(inputs: Projects_Title_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kas īstenotas.`)
};

/**
* | output |
* | --- |
* | "into practice." |
*
* @param {Projects_Title_2Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const projects_title_2 = /** @type {((inputs?: Projects_Title_2Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Title_2Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_projects_title_2(inputs)
	return en_projects_title_2(inputs)
});